import { put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import {
    GET_OPENING_BALANCES,
    GET_OPENING_BALANCES_SUCCESS,
    GET_OPENING_BALANCES_FAILURE,
    CREATE_OPENING_BALANCE,
    CREATE_OPENING_BALANCE_SUCCESS,
    CREATE_OPENING_BALANCE_FAILURE,
    UPDATE_OPENING_BALANCE,
    UPDATE_OPENING_BALANCE_SUCCESS,
    UPDATE_OPENING_BALANCE_FAILURE,
    DELETE_OPENING_BALANCE,
    DELETE_OPENING_BALANCE_SUCCESS,
    DELETE_OPENING_BALANCE_FAILURE,
    BULK_UPLOAD_OPENING_BALANCES,
    BULK_UPLOAD_OPENING_BALANCES_SUCCESS,
    BULK_UPLOAD_OPENING_BALANCES_FAILURE
} from '../../../actions/index.types';
import {
    getOpeningBalancesReq,
    createOpeningBalanceReq,
    updateOpeningBalanceReq,
    deleteOpeningBalanceReq,
    bulkUploadOpeningBalancesReq
} from '../../../../axios/request/SocietyPortal/OpeningBalanceReqs/OpeningBalanceReqs';

// Get All Opening Balances Saga
function* getOpeningBalancesSaga(action) {
    try {
        const response = yield getOpeningBalancesReq(action);
        if (response.success === true) {
            yield put({ type: GET_OPENING_BALANCES_SUCCESS, data: response });
        } else {
            yield put({ type: GET_OPENING_BALANCES_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to fetch opening balances");
        }
    } catch (error) {
        yield put({ type: GET_OPENING_BALANCES_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Create Opening Balance Saga
function* createOpeningBalanceSaga(action) {
    try {
        const response = yield createOpeningBalanceReq(action);
        if (response.success === true) {
            yield put({ type: CREATE_OPENING_BALANCE_SUCCESS, data: response.data });
            toast.success(response.message || "Opening balance created successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess();
            }
        } else {
            yield put({ type: CREATE_OPENING_BALANCE_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to create opening balance");
        }
    } catch (error) {
        yield put({ type: CREATE_OPENING_BALANCE_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Update Opening Balance Saga
function* updateOpeningBalanceSaga(action) {
    try {
        const response = yield updateOpeningBalanceReq(action);
        if (response.success === true) {
            yield put({ type: UPDATE_OPENING_BALANCE_SUCCESS, data: response.data });
            toast.success(response.message || "Opening balance updated successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess();
            }
        } else {
            yield put({ type: UPDATE_OPENING_BALANCE_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to update opening balance");
        }
    } catch (error) {
        yield put({ type: UPDATE_OPENING_BALANCE_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Delete Opening Balance Saga
function* deleteOpeningBalanceSaga(action) {
    try {
        const response = yield deleteOpeningBalanceReq(action);
        if (response.success === true) {
            yield put({ type: DELETE_OPENING_BALANCE_SUCCESS, data: response.data });
            toast.success(response.message || "Opening balance deleted successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess();
            }
        } else {
            yield put({ type: DELETE_OPENING_BALANCE_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to delete opening balance");
        }
    } catch (error) {
        yield put({ type: DELETE_OPENING_BALANCE_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Bulk Upload Opening Balances Saga
function* bulkUploadOpeningBalancesSaga(action) {
    try {
        const response = yield bulkUploadOpeningBalancesReq(action);
        if (response.success === true) {
            yield put({ type: BULK_UPLOAD_OPENING_BALANCES_SUCCESS, data: response.data });
            toast.success(response.message || "Opening balances imported successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess(response.data);
            }
        } else {
            yield put({ type: BULK_UPLOAD_OPENING_BALANCES_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to import opening balances");
        }
    } catch (error) {
        yield put({ type: BULK_UPLOAD_OPENING_BALANCES_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

export default function* OpeningBalanceSaga() {
    yield takeLatest(GET_OPENING_BALANCES, getOpeningBalancesSaga);
    yield takeLatest(CREATE_OPENING_BALANCE, createOpeningBalanceSaga);
    yield takeLatest(UPDATE_OPENING_BALANCE, updateOpeningBalanceSaga);
    yield takeLatest(DELETE_OPENING_BALANCE, deleteOpeningBalanceSaga);
    yield takeLatest(BULK_UPLOAD_OPENING_BALANCES, bulkUploadOpeningBalancesSaga);
}
